/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Brand } from "@fresh8/types/src";
import { Market, SportCompetitor } from "@fresh8/types/src/betData";
import { composeEventCompetitors } from "@fresh8/ad-data-composition/src/betData";
import { filterColor } from "./color";

export function areColorsAvailable(
  competitors: Array<SportCompetitor>
): boolean {
  const home = competitors?.[0];
  const away = competitors?.[1];

  const hasPrimaryAndSecondary = !!(
    home?.colors?.primary &&
    home?.colors?.primary.length &&
    home?.colors?.secondary &&
    home?.colors?.secondary?.length &&
    away?.colors?.primary &&
    away?.colors?.primary?.length &&
    away?.colors?.secondary &&
    away?.colors?.secondary?.length
  );

  return (
    hasPrimaryAndSecondary ||
    ((home?.colors?.home?.base?.length ?? 0) > 0 &&
      (home?.colors?.away?.base?.length ?? 0) > 0 &&
      (away?.colors?.home?.base?.length ?? 0) > 0 &&
      (away?.colors?.away?.base?.length ?? 0) > 0)
  );
}

export function areColorsAvailableInMarkets(
  brand: Brand,
  markets: Market[] | undefined = []
): boolean {
  const hasColorsForMarkets = markets
    .map(market => {
      const competitors = composeEventCompetitors(market.eventId);
      return competitors.value && areColorsAvailable(competitors.value);
    })
    .every(hasColors => hasColors);
  return brand.adTemplate?.team?.useTeamColors && hasColorsForMarkets;
}

/**
 * @deprecated use functional version `getColorsForCompetitors` from `@fresh8/ad-data-composition/src/lib/teamColors`
 */
export function setColors(
  competitors: Array<SportCompetitor>,
  background: string
): void {
  if (!competitors[0].colors || !competitors[1].colors) {
    return;
  }

  competitors[0].baseColor = filterColor(competitors[0].colors, background);
  competitors[1].baseColor = filterColor(competitors[1].colors, background);

  return;
}
